import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class PDF_create extends PureComponent {
  render() {
    return (
      <div className="row" id="pdf_create">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Create PDF</h2>
              <p>
                The Nexoid library includes a PDF engine. The PDF engine
                converts either HTML or a URL to PDF. Because of the nature or
                rather the potential size of a PDF; Nexoid creates and saves
                these PDF in regionalised AWS S3 buckets. These PDF buckets are
                set to automatedly delete the PDF file after 24 hours.
              </p>
              <p>
                Unlike other Nexoid API functions, the PDF create function does
                not have its own billing category and is charged as processing
                time.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Create PDF Example</h2>
            </section>
            <section>
              <h3>Example 1: Create PDF from URL</h3>
              <p>
                This example will create a PDF from a URL named
                "Nexoid_Website.pdf" and the link will expire in 60 minutes.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/pdf
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"url"</span>:{" "}
                  <span className="jsonY">"https://www.nexoid.com"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"filename"</span>:{" "}
                  <span className="jsonY">"Nexoid_Website.pdf"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"link_expire"</span>:{" "}
                  <span className="jsonP">60</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"link"</span>:{" "}
                  <span className="jsonY">
                    "https://nexoid-pdf.s3.amazonaws.com/pdf/l56ddwpb/Nexoid_Website.pdf?AWSAccessKeyId=AVIAELHGGJNKYDSFX5134Q
                    {"&"}
                    Expires=1173221756{"&"}
                    Signature=JTj2IdGh38d3h7S0CnQant0jNq0%3D"
                  </span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Create PDF from HTML</h3>
              <p>This example will create a PDF from an HTML string.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/pdf
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"html"</span>:{" "}
                  <span className="jsonY">
                    "{"<html><style type="}{" "}
                    <span className="jsonP">{'\\"'}</span>
                    {"text/css"}
                    <span className="jsonP">{'\\"'}</span>
                    {
                      ">@page { margin: 15mm; pagging: 0; size: 210mm 297mm; }</style><body><h1>Example HTML</h1><p>Hello World</p></body></html>"
                    }
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"link"</span>:{" "}
                  <span className="jsonY">
                    "https://nexoid-pdf.s3.amazonaws.com/pdf/kv734ndh21/myPDF.pdf?AWSAccessKeyId=AEIBELHJNKYDSPK5134Q
                    {"&"}
                    Expires=1173221756{"&"}
                    Signature=JTj2IdGh38d3h7S0CnQant0jNq0%3D"
                  </span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default PDF_create;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/PDF_create.js